import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';

const DoctorForgotPassword = React.lazy(() =>
  import('../../views/DoctorForgotPassword')
);

const params = [];
const DoctorForgotPasswordRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<></>} footer={<></>}>
        <DoctorForgotPassword />
      </Layout>
    </RouteParameter>
  );
};

DoctorForgotPasswordRoute.propTypes = {};

DoctorForgotPasswordRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DoctorForgotPasswordRoute);
